/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant'
import store from '../store/store'
const baseURL = ""
const service = function create() {
  return axios.create({
    baseURL: baseURL,
    timeout: 5000,  // 请求超时时间
  })
}()
/* request拦截器
 * 在请求之前对请求做处理 
 */
service.interceptors.request.use(config => {
  // Toast.loading({
  //   mask: true,
  //   message: '加载中...',
  //   forbidClick: true
  // })
  // 在发送请求之前做某件事
  if (
    config.method === "post" || config.method === "put"
  ) {
    // 序列化
    // config.data = qs.stringify(config.data);
  }
  // console.log(store)
  // console.log('will request', Cookies.get("jwt"))
  let jwt = store.state.jwt
  config.headers = Object.assign(config.headers, {
    "jwt": jwt
  })
  // console.log('will request', config)
  return config
}, error => {  //请求错误处理
  Toast.fail(error)
  Promise.reject(error)
})

/* respone拦截器
 * 在渲染页面之前对响应做处理 
 */
service.interceptors.response.use(
  response => {  //成功请求到数据
    // console.log('请求之后的response', response)
    // console.log(response.data)
    if (response.status === 200) {
      return response
    } else {
      if (response.data.msg) {
        Toast.fail(response.data.msg)
      } else {
        Toast.fail('未知错误')
      }
      return
    }
  }, error => {  //响应错误处理
    console.log('网络请求error', error)
    // Toast.fail(error)
    // 待完善
    if (error && error.response) {

    }
    return Promise.reject(error)
  }
)
export function get(url, params = {}) {
  return service({
    url: url,
    method: 'get',
    params
  })
}
export function post(url, data = {}) {
  let sendObject = {
    url: url,
    method: 'post',
    data: data
  }
  return service(sendObject)
}
export function put(url, data = {}) {
  return service({
    url: url,
    method: 'put',
    data: data
  })
}
export function deletes(url, data = {}) {
  return service({
    url: url,
    method: 'delete',
    data: data
  })
}
export {
  service
}
